import { render, staticRenderFns } from "./form5_1a.vue?vue&type=template&id=9ccf7e60&scoped=true&"
import script from "./form5_1a.vue?vue&type=script&lang=js&"
export * from "./form5_1a.vue?vue&type=script&lang=js&"
import style0 from "./form5_1a.vue?vue&type=style&index=0&id=9ccf7e60&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9ccf7e60",
  null
  
)

export default component.exports